<template>
  <div class="video" ref="videobox" style="position: fixed; top: 12vh; left: calc(50vw - 181px)" v-show="boxSelectShow">
    <div v-if="equipment" class="wait_info">
      <img :src="userInfo.avatar||avatar" alt="" />
      <div>
        <span>{{ userInfo.sendUserNickName }}</span>
        <!-- <span>等待对方接受邀请…</span> -->
      </div>
    </div>
    <div v-if="equipment" class="equipmenttext">
      未检测到对应设备，请稍后再试
    </div>
    <div class="modal_timer" v-if="timerData.timing">
      {{ timerData.h < 10 ? "0" + timerData.h : timerData.h }}:{{
        timerData.s < 10 ? "0" + timerData.s : timerData.s
      }}
    </div>
    <div class="mute" v-if="!audio">
      <!-- <div class="gridman" v-if="userInfo.sendCallType != 'audio'"> -->
      <div class="gridman">
        <img :src="userInfo.sendUserAvartar || userInfo.avatar || avatar" alt="" />
        {{ userInfo.sendUserNickName || userInfo.nickname }}
      </div>
      <div class="tips" v-if="setTime">{{ tips }}</div>
    </div>
    <div class="is-video" v-show="audio">
      <template v-if="switchShow">
        <video ref="video" id="video" width="200px" height="150px" autoplay playsinline muted="muted"></video>
        <video v-if="!equipment" @click="switchShow = !switchShow" ref="videos" class="other-side" width="200px"
          height="150px" autoplay playsinline></video>
      </template>
      <template v-else>
        <video @click="switchShow = !switchShow" class="other-side" ref="video" width="200px" height="150px" autoplay
          playsinline muted="muted"></video>
        <video ref="videos" id="video" width="200px" height="150px" autoplay playsinline></video>
      </template>
      <div class="tips" v-if="setTime">{{ tips }}</div>
    </div>
    <div class="video-call">
      <!-- <div class="vdr-celar" @click="close()"> -->
      <div class="vdr-celar" @click="onMinimize">
        <i class="iconfont iconsuoxiao"></i>
      </div>
      <div class="btns">
        <template v-if="onHang">
          <template v-if="audioBtn">
            <div class="sound order" @click="openOrderInfo">
              <i style="border: 1px solid #fff" class="iconfont iconchakandingdan1"></i>
              查看订单
            </div>
          </template>
        </template>
        <div class="hangup" @click="close()">
          <i class="iconfont icondianhua_tianchong"></i> 挂断
        </div>
        <div v-if="!audio && audioOn" class="sound jingyin" @click="onMute">
          <i style="border: 1px solid #fff" :style="{
                background: isMute ? '#fff' : 'transparent',
                color: isMute ? '#000' : '#fff',
                borderColor: isMute ? '#000' : '#fff',
              }" class="iconfont iconjingyin1"></i>
          静音
        </div>
        <template v-if="onHang">
          <template v-if="audioBtn">
            <div v-if="audio" class="sound switch" @click="enableAudio('1')">
              <i class="iconfont iconqiehuanyuyin"></i> 切换至音频
            </div>
          </template>
        </template>
      </div>
    </div>
    <orderInfo-modal ref="orderInfoModal"></orderInfo-modal>
  </div>
</template>

<script>
  import store from "@/store/";
  import {
    getAction
  } from "@/api/manage";
  import adapter from "webrtc-adapter";
  import {
    dragView
  } from "@/utils";
  import orderInfoModal from "@/components/user/modules/orderInfoModal";

  export default {
    components: {
      orderInfoModal
    },
    data() {
      return {
        tips: "已切换至语音通话",
        switchShow: true,
        boxSelectShow: false,
        videoEl: null,
        videocall: null,
        server: "wss://video.51jushifu.com:8989",
        opaqueId: "videocalltest-" + Date.parse(new Date()) / 10,
        janus: null,
        video: {
          myusername: null,
          yourusername: null,
        },
        url: {
          info: "/daxiang-cloud/sysUser/",
          videoCustomer: "/user/api/video_call/video_call_customer", // 推送自定义消息
          videoinform: "/user/api/video_call/video_call_inform", // 推送通知类消息
          sendHangup: "/user/api/video_call/sender_call_off", // 发起方挂断
        },
        userInfo: {},
        videoCallInstanceId: "",
        audio: true,
        setTime: false,
        isMute: false,
        gridman: {},
        avatar: require("@/assets/img/user.png"),
        onHang: true,
        audioBtn: false,
        elVideo: null,
        onremotestream: null, // 对方的流
        onlocalstream: null, // 本地流
        jsep: null,
        audioOn: false,
        equipment: false,
        minimize: false,
        timerData: {
          timing: false,
          timer: null,
          h: 0,
          s: 0,
        },
      };
    },
    mounted() {
      setTimeout(() => {
        console.log(store.state.userInfo);
      }, 1000);
    },
    methods: {
      dragView,
      // 跳转订单详情
      openOrderInfo() {
        if(sessionStorage.getItem('orderId')){
          this.$refs.orderInfoModal.open({
          id: sessionStorage.getItem('orderId')
        });
        }
        
      },
      onMinimize() {
        this.boxSelectShow = false;
        this.$parent.minimize = true;
      },
      // 发起方挂断
      sendHangup() {
        let params = {
          revieveUserId: this.userInfo.id||this.userInfo.sendUserId,
          sendUserNickName: store.state.userInfo.nickname,
          videoCallInstanceId: this.userInfo.videoCallInstanceId,
          sendUserAvartar: store.state.userInfo.avatar,
        };
        getAction(this.url.sendHangup, params);
      },
      // 切换至音频
      enableAudio(type) {
        // 关闭视频
        this.videocall.send({
          message: {
            request: "set",
            video: false,
          },
        });
        //  打开音频
        // this.videocall.send({
        //   message: {
        //     request: 'set',
        //     audio: true,
        //   },
        // })

        if (type) {
          console.log(123)
          let data = {
            type: "cmd", //类型为命令
            value: "video_close",
          };
          // 发送消息给对方
          this.videocall.data({
            text: JSON.stringify(data),
            error: function (reason) {
              console.log(reason);
            },
            success: function () {},
          });
        }
        this.audioOn = true;
        this.audio = false;
        setTimeout(() => {
          this.setTime = false;
        }, 2000);
      },
      onMute() {
        let _this = this;
        this.videocall.send({
          message: {
            request: "set",
            audio: _this.isMute,
          },
        });
        this.isMute = !this.isMute;
      },
      // 给接收方推送消息
      forwardNews(user) {
        if (this.userInfo.typeCode != "receiver") {
          this.userInfo.videoCallInstanceId = JSON.stringify(
            Date.parse(new Date()) / 1000
          );
        }
        let parpams = {
          isVideoCall: user.sendCallType == "audio" ? false : true, // 是否是视频通话
          revieveUserId: user.id,
          sendUserAvartar: store.state.userInfo.avatar,
          sendUserId: store.state.userInfo.id,
          sendUserNickName: store.state.userInfo.nickname,
          videoCallInstanceId: this.userInfo.videoCallInstanceId, // 事件戳
          type:'order',
          businessId:sessionStorage.getItem('orderId')||''
        };
        getAction(this.url.videoCustomer, parpams);
        getAction(this.url.videoinform, parpams);
      },
      // 打开摄像头
      openCamera() {
        let _this = this;
        let constraints = {
          audio: true,
          video: {
            width: {
              min: 1280,
            },
            height: {
              min: 720,
            },
          },
        };
        navigator.mediaDevices
          .getUserMedia(constraints)
          .then(function (stream) {
            _this.elVideo = document.getElementById("video");
            _this.elVideo.srcObject = stream;
            _this.elVideo.onloadedmetadata = function (e) {
              _this.elVideo.play();
            };
          })
          .catch(function (err) {
            console.log(err.name + ": " + err.message);
            console.log("摄像头打开失败");
            _this.equipment = true;
          });
      },
      cc() {
        console.log(this.onlocalstream)
        console.log(this.onlocalstream.getTracks())
        if (this.onlocalstream) {
          console.log(111);
          this.onlocalstream.getTracks().forEach((track) => {
            track.stop();
          });
        }
        if (this.onremotestream) {
          console.log(111);
          this.onremotestream.getTracks().forEach((track) => {
            track.stop();
          });
        }
      },
      // 关闭过渡视频流
      closeVideo() {
        // 关闭摄像头
        if (this.onlocalstream) {
          this.onlocalstream.getTracks().forEach((track) => {
            track.stop();
          });
        }
        if (this.onremotestream) {
          this.onremotestream.getTracks().forEach((track) => {
            track.stop();
          });
        }
        if (this.elVideo) {
          this.elVideo.srcObject.getTracks().forEach((track) => {
            track.stop();
          });
        }

      },
      init() {
        let userid = store.state.userInfo.id;
        console.log(userid);
        let _this = this;
        Janus.init({
          debug: true,
          dependencies: Janus.useDefaultDependencies({
            adapter: adapter,
          }),
          callback: () => {
            if (!Janus.isWebrtcSupported()) {
              console.log("is not Supported Webrtc!");
              return;
            }

            _this.janus = new Janus({
              server: _this.server,
              success: function () {
                // Attach to VideoCall plugin
                _this.janus.attach({
                  plugin: "janus.plugin.videocall",
                  opaqueId: _this.opaqueId,
                  success: function (pluginHandle) {
                    _this.videocall = pluginHandle;

                    _this.registerUsername(userid);
                  },
                  error: function (error) {
                    Janus.error("  -- Error attaching plugin...", error);
                  },
                  // 同意
                  consentDialog: function (on) {
                    console.log(on);
                  },
                  webrtcState: function (on) {
                    console.log(on);
                  },
                  onmessage: function (msg, jsep) {
                    console.log(msg);
                    console.log(jsep);

                    var result = msg["result"];
                    if (result) {
                      if (result["list"]) {} else if (result["event"]) {
                        var event = result["event"];
                        if (event === "incomingcall") {
                          console.log(
                            "Incoming call from " + result["username"] + "!"
                          );
                          _this.video.yourusername = result["username"];
                          // Notify user
                          _this.incomingcall(jsep);
                          // _this.$confirm({
                          //   title: `未知来电${_this.video.yourusername}!`,
                          //   content: `未知来电${_this.video.yourusername}!`,
                          //   onOk() {
                          //     _this.videocall.createAnswer({
                          //       jsep: jsep,
                          //       media: {
                          //         data: true,
                          //       },
                          //       simulcast: false,
                          //       success: function (jseps) {
                          //         var body = {
                          //           request: 'accept',
                          //         }
                          //         _this.videocall.send({
                          //           message: body,
                          //           jsep: jseps,
                          //         })
                          //       },
                          //       error: function (error) {
                          //         Janus.error('WebRTC error:', error)
                          //         // alert('WebRTC error... ' + error.message)
                          //       },
                          //     })
                          //   },
                          //   onCancel() {
                          //     _this.doHangup()
                          //   },
                          // })
                        } else if (event === "accepted") {
                          var peer = result["username"];
                          if (!peer) {
                            Janus.log("Call started!");
                          } else {
                            Janus.log(peer + " accepted the call!");
                            _this.video.yourusername = peer;
                          }
                          // Video call can start
                          if (jsep)
                            _this.videocall.handleRemoteJsep({
                              jsep: jsep,
                            });
                        } else if (event === "update") {
                          // An 'update' event may be used to provide renegotiation attempts
                          if (jsep) {
                            if (jsep.type === "answer") {
                              _this.videocall.handleRemoteJsep({
                                jsep: jsep,
                              });
                            } else {
                              _this.videocall.createAnswer({
                                jsep: jsep,
                                media: {
                                  data: true,
                                }, // Let's negotiate data channels as well
                                success: function (jsep) {
                                  Janus.debug("Got SDP!", jsep);
                                  var body = {
                                    request: "set",
                                  };
                                  _this.videocall.send({
                                    message: body,
                                    jsep: jsep,
                                  });
                                },
                                error: function (error) {
                                  Janus.error("WebRTC error:", error);
                                },
                              });
                            }
                          }
                          // 挂断
                        } else if (event === "hangup") {
                          // Reset status
                          // _this.videocall.hangup()
                          _this.$notify.closeAll()
                          _this.$notify.info({
                            title: "提示",
                            message: "已挂断！",
                          });
                          _this.onHang = false;
                          _this.tips = "通话已结束";
                          _this.setTime = true;
                          _this.close();
                        }
                      }
                    } else {
                      // FIXME Error?
                      var error = msg["error"];
                      // TODO Reset status
                      _this.videocall.hangup();
                    }
                  },
                  // 本地流
                  onlocalstream: function (stream) {
                    // 关闭初始摄像头
                    if (_this.elVideo) {
                      _this.elVideo.srcObject.getTracks().forEach((track) => {
                        track.stop();
                      });
                    }
                    console.log(stream);
                    console.log("222222222222222222222", _this.$refs.video);
                    Janus.attachMediaStream(_this.$refs.video, stream);
                    if (
                      _this.videocall.webrtcStuff.pc.iceConnectionState !==
                      "completed" &&
                      _this.videocall.webrtcStuff.pc.iceConnectionState !==
                      "connected"
                    ) {
                      // 没有远程视频
                      // _this.$message.info('没有本地远程视频')
                    }
                    var videoTracks = stream.getVideoTracks();
                    _this.onlocalstream = stream
                    if (!videoTracks || videoTracks.length === 0) {
                      // 没有摄像头
                      // _this.$message.info('没有摄像头')
                    }
                  },
                  // 对方的流
                  onremotestream: function (stream) {
                    // _this.closeVideo()
                    console.log(stream);
                    console.log("333333333333333333333333", _this.$refs.videos);
                    _this.switchShow = false;
                    _this.audioBtn = true;
                    Janus.attachMediaStream(_this.$refs.videos, stream);
                    var videoTracks = stream.getVideoTracks();
                    _this.onremotestream = stream
                    // 画质
                    // _this.videocall.send({ message: { request: 'set', bitrate: 128000 } })
                    if (!videoTracks || videoTracks.length === 0) {
                      // 没有远程视频
                      // _this.$message.info('没有远程视频')
                    }
                  },
                  // 接收对方发的消息
                  ondata: function (data) {
                    console.log(data);
                    console.log("接收消息");
                    let msgData = JSON.parse(data);
                    console.log(msgData);
                    if (
                      msgData &&
                      msgData.type == "cmd" &&
                      msgData.value == "video_close"
                    ) {
                      _this.enableAudio();
                    }
                  },
                });
              },
            });
          },
        });
      },
      // 计时
      onTiming() {
        this.timerData.timing = true;
        this.timerData.timer = setInterval(() => {
          this.timerData.s = this.timerData.s + 1;
          if (this.timerData.s >= 60) {
            this.timerData.h = this.timerData.h + 1;
            this.timerData.s = 0;
          }
          this.$emit("toTimer", this.timerData);
        }, 1000);
      },
      // 关闭定时器
      closeTimer() {
        if (this.timerData.timer) clearInterval(this.timerData.timer);
      },
      // 接听
      onAnswer(jsep) {
        let _this = this;
        _this.videocall.createAnswer({
          jsep: jsep,
          media: {
            data: true,
          },
          simulcast: false,
          success: function (jseps) {
            var body = {
              request: "accept",
            };
            _this.videocall.send({
              message: body,
              jsep: jseps,
            });
            _this.onTiming();
            console.log("5555555555555555555");
            console.log(_this.userInfo);
            if (
              _this.userInfo.callType == "audio" ||
              _this.userInfo.sendCallType == "audio" ||
              !JSON.parse(_this.userInfo.isVideoCall)
            ) {
              _this.audioOn = true;
              _this.videocall.send({
                message: {
                  request: "set",
                  video: false,
                },
              });
            }
          },
          error: function (error) {
            Janus.error("WebRTC error:", error);
            // alert("WebRTC error... " + error.message);
            _this.$message.closeAll()
              if(_this.equipment ==true){
                      
              _this.$message.error('未检测到对应设备，请稍后再试');
              // setTimeout(() => {
              _this.close()
              _this.sendHangup()  
              // }, 2000);
            }
          },
        });
      },
      // 来电
      incomingcall(jsep) {
        this.jsep = jsep;
        this.onAnswer(jsep);
      },

      // 注册用户
      registerUsername(username) {
        let register = {
          request: "register",
          // username: `${username}_${this.userInfo.videoCallInstanceId}`, // 用户名必须为字符串
          username: `${username}${this.userInfo.videoCallInstanceId}`, // 用户名必须为字符串
        };
        this.videocall.send({
          message: register,
        });
        if (this.userInfo.typeCode == "receiver") {
          setTimeout(() => {
            console.log(this.userInfo.sendUserId);
            // this.doCall(this.userInfo.sendUserId + '_' + this.userInfo.videoCallInstanceId)
            this.doCall(
              this.userInfo.sendUserId + this.userInfo.videoCallInstanceId
            );
          }, 1000);
        }
      },

      // 给对方打电话
      doCall(peer) {
        console.log(peer);
        let _this = this;
        this.videocall.createOffer({
          // By default, it's sendrecv for audio and video...
          media: {
            data: true,
          },
          simulcast: false,
          success: function (jsep) {
            console.log(jsep);
            var body = {
              request: "call",
              username: peer, // 对方电话号码
            };
            _this.videocall.send({
              message: body,
              jsep: jsep,
            });
            _this.onTiming();
            if (
              _this.userInfo.callType == "audio" ||
              _this.userInfo.sendCallType == "audio"
            ) {
              _this.audioOn = true;
              _this.enableAudio(1);
              // _this.videocall.send({
              //   message: {
              //     request: "set",
              //     video: false,
              //   },
              // });
            }
          },
          error: function (error) {
            console.log("WebRTC error...", error);
            // alert('WebRTC error... ' + error.message)
            _this.$message.closeAll()
              if(_this.equipment ==true){
                      
              _this.$message.error('未检测到对应设备，请稍后再试');
              // setTimeout(() => {
              _this.close()
              _this.sendHangup()  
              // }, 2000);
            }
          },
        });
      },
      // 挂机
      doHangup() {
        console.log("挂断");
        this.onHang = false;
        this.tips = "通话已结束";
        this.setTime = true;
        // Hangup a call
        var hangup = {
          request: "hangup",
        };
        this.videocall.send({
          message: hangup,
        });
        this.videocall.hangup();
        this.janus.destroy();
        // yourusername = null;
      },
      close() {
        // sessionStorage.removeItem('orderId')
        this.closeTimer();
        this.closeVideo();
        this.boxSelectShow = false;
        this.doHangup();
        this.minimize = false;
        this.switchShow = true;
        this.boxSelectShow = false;

        this.video = {
          myusername: null,
          yourusername: null,
        };
        this.timerData = {
          timing: false,
          timer: null,
          h: 0,
          s: 0,
        }
        this.audio = true;
        this.setTime = false;
        this.isMute = false;
        this.gridman = {};
        this.onHang = true;
        this.audioBtn = false;
        this.elVideo = null;
        this.jsep = null;
        this.audioOn = false;
        if (this.userInfo.typeCode != "receiver") {
          this.sendHangup();
        }
      },
      startVideo(item) {
        let _this = this;
        this.setTime = false;
        this.tips = "已切换至语音通话";
        console.log(item);
        this.userInfo = item;
        _this.boxSelectShow = true;
        this.$nextTick(() => {
          // 是发起方才调用
          if (this.userInfo.id) {
            this.forwardNews(this.userInfo);
          }
          // this.onTiming();
          this.init();
          this.dragView(this.$refs.videobox, this.$refs.videobox);
          this.openCamera();
          if (
            this.userInfo.callType == "audio" ||
            this.userInfo.sendCallType == "audio"
          ) {
            this.audio = false;
            this.audioOn = false;
          }
        });
      },
    },
  };
</script>

<style lang='scss' scoped>
  .video {
    // margin-left: calc(50vw - 181px);
    width: 362px !important;
    max-height: 732px !important;
    // height: calc(100vh - 205px) !important;
    height: 640px !important;
    background: #333 !important;
    border-radius: 4px;
    z-index: 2055;

    &.active:before {
      z-index: -1;
      display: none;
    }

    .modal_timer {
      position: absolute;
      color: #fff;
      font-size: 14px;
      top: 485px;
      text-align: center;
      width: 100%;
      z-index: 2000;
    }

    .equipmenttext {
      position: absolute;
      top: 357px;
      left: 50%;
      margin-left: -98px;
      color: #fff;
      z-index: 15;
    }

    .wait_info {
      position: absolute;
      display: flex;
      top: 30px;
      left: 30px;

      img {
        width: 72px;
        height: 72px;
        border-radius: 2px;
      }

      &>div {
        color: #fff;
        font-size: 16px;
        display: flex;
        flex-direction: column;
        margin-left: 19px;

        &>span:last-child {
          font-size: 12px;
          margin-top: 5px;
        }
      }
    }
  }

  .tips {
    position: absolute;
    color: #fff;
    bottom: 185px;
    font-size: 12px;
    left: 50%;
    width: 96px;
    margin-left: -48px;
    text-align: center;
  }

  .mute {
    position: absolute;
    // left: 50%;
    // margin-left: -187.5px;
    // top: 5vh;
    width: 362px !important;
    // height: calc(100vh - 205px) !important;
    height: 640px !important;
    background: #333;
    z-index: 10;

    .gridman {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: #fff;
      font-size: 16px;
      margin-top: 30px;

      img {
        width: 120px;
        height: 120px;
        border-radius: 5px;
        margin-bottom: 15px;
        object-fit: cover;
      }
    }
  }

  .is-video {
    position: absolute;
    // left: 50%;
    // margin-left: -187.5px;
    // top: 5vh;
    width: 362px !important;
    // height: calc(100vh - 205px) !important;
    height: 640px !important;
    z-index: 3;
  }

  #video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  video {
    width: 100%;
  }

  .other-side {
    position: absolute;
    // width: 94px;
    // height: 113px;
    width: 90px;
    height: 160px;
    // right: 20px;
    // top: 66px;
    left: 30px;
    top: 30px;
    background: #d8d8d8;
    border-radius: 4px;
    z-index: 3;
    object-fit: cover;
  }

  .video-call {
    .btns {
      // width: 200px;
      width: 206px;
      // height: 75px;
      height: 64px;
      display: flex;
      // justify-content: space-around;
      justify-content: center;
      position: absolute;
      // bottom: 93px;
      bottom: 40px;
      left: 50%;
      margin-left: -100px;
      color: #fff;
      z-index: 100;

      &>div {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        font-size: 12px;
        height: 64px;

        &.order {
          position: absolute;
          left: 0;
        }

        &.switch {
          position: absolute;
          right: 0;
        }

        &.jingyin {
          position: absolute;
          right: 0;
        }

        &:hover {
          opacity: 0.7;
        }

        i {
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;

          &.iconchakandingdan1 {
            background: #fff;
            color: #2f3133;
          }

          &.iconqiehuanyuyin {
            border: 1px solid rgba($color: #000000, $alpha: 0.5);
            font-size: 19px;
            background: rgba($color: #000000, $alpha: 0.5);
          }

          &.icondianhua_tianchong {
            background: #f75658;
            font-size: 39px;
            line-height: 39px;
          }
        }
      }
    }

    .vdr-celar {
      position: absolute;
      // top: 9px;
      // right: 9px;
      top: 15px;
      right: 24px;
      // background: #e8f1ff;
      border-radius: 50%;
      width: 18px;
      height: 18px;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      z-index: 5;

      i {
        font-size: 18px !important;
        // margin-right: 0 !important;
        // margin-top: 2px;
      }
    }
  }
</style>